var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4297 30.168V16.1406L28.2539 8.8125C28.3268 9.08594 28.3633 9.43229 28.3633 9.85156V20.502C28.3633 21.4954 28.1947 22.2292 27.8574 22.7031C27.5293 23.168 27.0462 23.5827 26.4082 23.9473L15.7031 30.0449C15.6576 30.0723 15.612 30.0951 15.5664 30.1133C15.5208 30.1406 15.4753 30.1589 15.4297 30.168ZM13.5566 30.168C13.5111 30.1589 13.4655 30.1406 13.4199 30.1133C13.3835 30.0951 13.3424 30.0723 13.2969 30.0449L2.57812 23.9473C1.94922 23.5827 1.46615 23.168 1.12891 22.7031C0.791667 22.2292 0.623047 21.4954 0.623047 20.502V9.85156C0.623047 9.43229 0.659505 9.08594 0.732422 8.8125L13.5566 16.1406V30.168ZM14.5 14.5L1.60742 7.18555C1.80794 7.00326 2.06315 6.82552 2.37305 6.65234L7.39062 3.79492L20.3379 11.1914L14.5 14.5ZM22.2383 10.1113L9.23633 2.72852L12.0117 1.15625C12.8594 0.664062 13.6888 0.417969 14.5 0.417969C15.3021 0.417969 16.127 0.664062 16.9746 1.15625L26.627 6.65234C26.9277 6.82552 27.1784 7.00326 27.3789 7.18555L22.2383 10.1113Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.6b5f277d1717827ebc0a23a9c371ddb6.svg";
export { ForwardRef as ReactComponent };